const PROFILE_API_BASE = "https://alerta-maceio-api-production.up.railway.app/api";
const PROFILE_KEY = "vigial_user_profile_v1";
const PREMIUM_KEY = "vigial_premium_v1";

const TRUST_LEVEL_STYLE = [
  { icon: "eye", color: "#9E9E9E" },
  { icon: "badge-check", color: "#1E88E5" },
  { icon: "radar", color: "#2E7D32" },
  { icon: "crown", color: "#D4AF37" },
];
window.TRUST_LEVEL_STYLE = TRUST_LEVEL_STYLE;

function loadProfile() {
  try { return JSON.parse(localStorage.getItem(PROFILE_KEY) || "null"); } catch (e) { return null; }
}

function PasswordField({ value, onChange, placeholder, style }) {
  const { Icon } = window.VigiALDesignSystem_ff2dec;
  const [show, setShow] = React.useState(false);
  return (
    <div style={{ position: "relative", marginBottom: 8, ...style }}>
      <input
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: "9px 34px 9px 9px", borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)" }}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        style={{ position: "absolute", right: 4, top: 0, bottom: 0, background: "transparent", border: "none", cursor: "pointer", padding: "0 8px", display: "flex", alignItems: "center" }}
      >
        <Icon name={show ? "eye-off" : "eye"} size={15} color="var(--color-text-muted)" />
      </button>
    </div>
  );
}
function saveProfileToStorage(profile) {
  try { localStorage.setItem(PROFILE_KEY, JSON.stringify(profile)); } catch (e) {}
  // The header chip (App.jsx) only re-reads localStorage on tab change, so
  // clearing the profile while already on the Perfil tab (e.g. logout) left
  // the previous account's name/avatar stuck up there. This event lets it
  // refresh immediately regardless of which tab is active.
  window.dispatchEvent(new CustomEvent("vigial:profileChanged", { detail: profile }));
}
function isValidEmail(email) {
  return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);
}
function isPremium() {
  try { return localStorage.getItem(PREMIUM_KEY) === "true"; } catch (e) { return false; }
}
function setPremium(value) {
  try { localStorage.setItem(PREMIUM_KEY, value ? "true" : "false"); } catch (e) {}
}
window.isPremium = isPremium;
window.setPremium = setPremium;
window.loadProfile = loadProfile;

const DIGEST_ENABLED_KEY = "vigial_weekly_digest_enabled_v1";
function loadDigestEnabled() {
  try { return localStorage.getItem(DIGEST_ENABLED_KEY) === "true"; } catch (e) { return false; }
}
function saveDigestEnabled(v) {
  try { localStorage.setItem(DIGEST_ENABLED_KEY, v ? "true" : "false"); } catch (e) {}
}
function loadSavedPlacesForDigest() {
  try { return JSON.parse(localStorage.getItem(window.PLACES_KEY || "vigial_saved_places_v1") || "[]"); } catch (e) { return []; }
}

function catLabelForTrends(lang, catId) {
  const cat = (window.CATS || []).find((c) => c.id === catId);
  return cat ? t(lang, cat.key) : catId;
}

function computeTrends(reports) {
  const now = Date.now();
  const D = 24 * 3600 * 1000;
  const periodA = reports.filter((r) => now - r.createdAt <= 30 * D);
  const periodB = reports.filter((r) => now - r.createdAt > 30 * D && now - r.createdAt <= 60 * D);
  function countBy(list, key) {
    const map = {};
    list.forEach((r) => { const k = r[key] || "?"; map[k] = (map[k] || 0) + 1; });
    return map;
  }
  const byBairroA = countBy(periodA, "bairro");
  const byBairroB = countBy(periodB, "bairro");
  const byCatA = countBy(periodA, "category");
  const ranked = Object.entries(byBairroA)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5)
    .map(([bairro, count]) => ({ bairro, count, prevCount: byBairroB[bairro] || 0 }));
  const topCatEntry = Object.entries(byCatA).sort((a, b) => b[1] - a[1])[0];
  return {
    ranked,
    topCategory: topCatEntry ? topCatEntry[0] : null,
    topCategoryCount: topCatEntry ? topCatEntry[1] : 0,
    totalPeriodA: periodA.length,
  };
}

const AVATAR_ICON_PRESETS = [
  { id: "shield", type: "icon", icon: "shield", bg: "#1B3A5C", premium: false },
  { id: "flashlight", type: "icon", icon: "flashlight", bg: "#514B3C", premium: false },
  { id: "car", type: "icon", icon: "car", bg: "#0D1B2C", premium: false },
  { id: "shield-check", type: "icon", icon: "shield-check", bg: "#1F6F54", premium: false },
  { id: "shield-alert", type: "icon", icon: "shield-alert", bg: "#8A2E2E", premium: false },
  { id: "siren", type: "icon", icon: "siren", bg: "#C81E2C", premium: false },
  { id: "radar", type: "icon", icon: "radar", bg: "#2B4C6F", premium: false },
  { id: "eye", type: "icon", icon: "eye", bg: "#3E5C4E", premium: false },
  { id: "badge-check", type: "icon", icon: "badge-check", bg: "#8A6A1E", premium: false },
  { id: "radio", type: "icon", icon: "radio", bg: "#4A3E5C", premium: false },
];

function AVATAR_PRESETS_INIT() { return [...AVATAR_ICON_PRESETS]; }
const AVATAR_PRESETS = AVATAR_PRESETS_INIT();

// Migrates a profile saved by an older face schema into the current one
// (DiceBear-backed), so avatars saved before a rewrite still render:
//   v1 (5-uniform face system) -> had .skin/.hair/.long/.cap/.branch
//   v2 (hand-drawn modular system) -> had .faceShape/.eyeShape/.accessory,
//     none of which the DiceBear-backed system reads anymore
function migrateOldCustomFace(v) {
  if (!v) return null;
  if (v.hairStyle || v.faceShape) {
    // v2 -> current: everything else lines up, but "boné" used to be a
    // separate accessory layered over any hairstyle; it's a hairStyle
    // choice of its own now.
    if (v.accessory === "bone" || v.hairStyle === "bone") return { ...v, hairStyle: "chapeu" };
    if (v.beard === "cavanhaque") return { ...v, beard: "rala" };
    return v;
  }
  const skinMap = { light: "clara", medium: "morena", dark: "negraRetinta" };
  const hairColorMap = { dark: "castanho", black: "preto", blonde: "loiro", gray: "grisalho", auburn: "castanho" };
  const glassesMap = { round: "redondo", aviator: "aviador" };
  return {
    ...window.DEFAULT_AVATAR_FACE,
    skin: skinMap[v.skin] || "clara",
    hairColor: hairColorMap[v.hair] || "castanho",
    hairStyle: v.cap ? "chapeu" : v.long ? "soltoLongo" : "social",
    beard: (v.facialHair === "beard" || v.facialHair === "both") ? "cheia" : "nenhuma",
    mustache: (v.facialHair === "mustache" || v.facialHair === "both") ? "chevron" : "nenhum",
    glasses: glassesMap[v.glasses] || "nenhum",
    specialUniform: "none",
  };
}

function AvatarBadge({ avatar, size, locked }) {
  const { Icon } = window.VigiALDesignSystem_ff2dec;
  const s = size || 36;
  let node = null;
  if (avatar && avatar.type === "photo" && avatar.value) {
    node = <img src={avatar.value} alt="" style={{ width: s, height: s, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />;
  } else if (avatar && avatar.type === "custom" && avatar.value) {
    node = <window.AvatarSvg face={migrateOldCustomFace(avatar.value)} size={s} />;
  } else if (avatar && avatar.type === "preset") {
    const preset = AVATAR_PRESETS.find((p) => p.id === avatar.value);
    if (preset) {
      node = (
        <div style={{ width: s, height: s, borderRadius: "50%", background: preset.bg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <Icon name={preset.icon} size={Math.round(s * 0.55)} color="#fff" />
        </div>
      );
    }
  }
  if (!node) {
    node = (
      <div style={{ width: s, height: s, borderRadius: "50%", background: "var(--color-brand-tint)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <Icon name="user" size={Math.round(s * 0.5)} color="var(--color-brand-deep)" />
      </div>
    );
  }
  if (!locked) return node;
  return (
    <div style={{ position: "relative", width: s, height: s, flexShrink: 0 }}>
      <div style={{ opacity: 0.35 }}>{node}</div>
      <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Icon name="lock" size={Math.round(s * 0.4)} color="var(--color-text-primary)" />
      </div>
    </div>
  );
}
window.AvatarBadge = AvatarBadge;

function readAndResizeImage(file, maxSize) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("read error"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("image error"));
      img.onload = () => {
        let { width, height } = img;
        if (width > height) {
          if (width > maxSize) { height = Math.round((height * maxSize) / width); width = maxSize; }
        } else if (height > maxSize) {
          width = Math.round((width * maxSize) / height); height = maxSize;
        }
        const canvas = document.createElement("canvas");
        canvas.width = width; canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", 0.85));
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

function ProfileScreen({ lang }) {
  const { Button, Icon } = window.VigiALDesignSystem_ff2dec;
  const [profile, setProfile] = React.useState(loadProfile);
  const [editing, setEditing] = React.useState(!profile);
  const [name, setName] = React.useState(profile ? profile.name : "");
  const [email, setEmail] = React.useState(profile ? profile.email : "");
  const [username, setUsername] = React.useState(profile ? profile.username || "" : "");
  const [avatarDraft, setAvatarDraft] = React.useState(profile ? profile.avatar || null : null);
  const [customFace, setCustomFace] = React.useState(() => (profile && profile.avatar && profile.avatar.type === "custom") ? migrateOldCustomFace(profile.avatar.value) : window.DEFAULT_AVATAR_FACE);
  const [avatarError, setAvatarError] = React.useState(null);
  const fileInputRef = React.useRef(null);
  const mountedRef = React.useRef(true);
  React.useEffect(() => () => { mountedRef.current = false; }, []);
  const [nameErr, setNameErr] = React.useState(false);
  const [emailErr, setEmailErr] = React.useState(false);
  const [usernameErr, setUsernameErr] = React.useState(false);
  const [status, setStatus] = React.useState("idle");
  const [premium, setPremiumState] = React.useState(isPremium);
  const [planMsg, setPlanMsg] = React.useState(null);
  const [selectedPlan, setSelectedPlan] = React.useState("monthly");
  const [accountSync, setAccountSync] = React.useState(null);
  const [pixCharge, setPixCharge] = React.useState(null);
  const [pixPolling, setPixPolling] = React.useState(false);
  const [pixCopied, setPixCopied] = React.useState(false);
  const [digestEnabled, setDigestEnabled] = React.useState(loadDigestEnabled);
  const [digestPreview, setDigestPreview] = React.useState(null);
  const [digestLoading, setDigestLoading] = React.useState(false);
  const [trends, setTrends] = React.useState(null);
  const [trendsLoading, setTrendsLoading] = React.useState(false);
  const [deviceTrust, setDeviceTrust] = React.useState(null);
  const [verifyEmail, setVerifyEmail] = React.useState("");
  const [verifyStep, setVerifyStep] = React.useState("idle");
  const [verifyCode, setVerifyCode] = React.useState("");
  const [verifyError, setVerifyError] = React.useState("");
  const [verifyLoading, setVerifyLoading] = React.useState(false);
  const [acceptedTerms, setAcceptedTerms] = React.useState(false);
  const [isReturningAccount, setIsReturningAccount] = React.useState(false);
  const [premiumTrialExpiresAt, setPremiumTrialExpiresAt] = React.useState(null);
  const [showPasswordForm, setShowPasswordForm] = React.useState(false);
  const [currentPasswordInput, setCurrentPasswordInput] = React.useState("");
  const [newPasswordInput, setNewPasswordInput] = React.useState("");
  const [confirmPasswordInput, setConfirmPasswordInput] = React.useState("");
  const [passwordError, setPasswordError] = React.useState("");
  const [passwordSaving, setPasswordSaving] = React.useState(false);
  const [passwordSavedMsg, setPasswordSavedMsg] = React.useState(false);
  const [showLoginForm, setShowLoginForm] = React.useState(() => {
    // Set by the "Já tenho cadastro" link on the Mapa signup banner so it
    // can jump straight to the login form instead of just landing on this
    // screen's default (signup) state — consumed once, not sticky.
    if (window.__vigialOpenLogin) { window.__vigialOpenLogin = false; return true; }
    return false;
  });
  const [rememberOnLogout, setRememberOnLogout] = React.useState(true);
  const [loginEmail, setLoginEmail] = React.useState("");
  const [loginPassword, setLoginPassword] = React.useState("");
  const [loginError, setLoginError] = React.useState("");
  const [loginLoading, setLoginLoading] = React.useState(false);
  const [showForgotPassword, setShowForgotPassword] = React.useState(false);
  const [forgotStep, setForgotStep] = React.useState("email");
  const [forgotEmail, setForgotEmail] = React.useState("");
  const [forgotCode, setForgotCode] = React.useState("");
  const [forgotNewPassword, setForgotNewPassword] = React.useState("");
  const [forgotConfirmPassword, setForgotConfirmPassword] = React.useState("");
  const [forgotLoading, setForgotLoading] = React.useState(false);
  const [forgotError, setForgotError] = React.useState("");

  React.useEffect(() => {
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    if (!deviceId) return;
    fetch(`${PROFILE_API_BASE}/device-trust/mine`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ deviceId }),
    }).then((r) => r.json()).then(setDeviceTrust).catch(() => {});
    fetch(`${PROFILE_API_BASE}/account-sync/mine`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ deviceId }),
    }).then((r) => r.json()).then((data) => {
      setAccountSync(data);
      if (data && data.linked && typeof data.digestEnabled === "boolean") {
        setDigestEnabled(data.digestEnabled);
        saveDigestEnabled(data.digestEnabled);
      }
      // A Pix charge left pending (person closed the app before the QR
      // screen's own polling confirmed it, or paid after it gave up) never
      // gets rechecked otherwise — re-verify once whenever the profile
      // screen is opened again, so it self-heals without needing the QR
      // screen to still be open.
      if (data && data.premiumPending && !data.premium) {
        fetch(`${PROFILE_API_BASE}/premium/check-pix`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ deviceId }),
        })
          .then((r) => r.json())
          .then((res) => {
            if (res && res.premium) {
              fetch(`${PROFILE_API_BASE}/account-sync/mine`, {
                method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ deviceId }),
              }).then((r2) => r2.json()).then(setAccountSync).catch(() => {});
              if (window.setPremium) window.setPremium(true);
              setPremiumState(true);
            }
          })
          .catch(() => {});
      }
    }).catch(() => {});
  }, []);

  function sendVerificationCode() {
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    const cleanEmail = verifyEmail.trim();
    if (!isValidEmail(cleanEmail)) { setVerifyError(t(lang, "invalidEmailErr")); return; }
    if (!acceptedTerms) { setVerifyError(t(lang, "acceptTermsRequiredErr")); return; }
    setVerifyLoading(true); setVerifyError("");
    fetch(`${PROFILE_API_BASE}/verify-email/send`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ deviceId, email: cleanEmail }),
    })
      .then((r) => r.json())
      .then((res) => {
        setVerifyLoading(false);
        if (res.error) { setVerifyError(res.error); return; }
        setVerifyStep("sent");
      })
      .catch(() => { setVerifyLoading(false); setVerifyError(t(lang, "couldNotSend")); });
  }

  function applyLinkedAccountResult(res, email) {
    setDeviceTrust({ trustScore: res.trustScore, trustLevel: res.trustLevel, verifiedEmail: email, hasPassword: !!res.hasPassword });
    setIsReturningAccount(!!res.isReturningAccount);
    // The header badge (App.jsx) fetched trust level once at mount, before
    // this device was linked to an account — without this it stays stuck
    // showing "Observador" after logging in even though this screen's own
    // deviceTrust (set just above) already has the real level.
    if (window.refreshMyTrustLevel) window.refreshMyTrustLevel();
    setPremiumTrialExpiresAt(res.premiumTrialExpiresAt || null);
    if (res.premium && window.setPremium) { window.setPremium(true); setPremiumState(true); }
    if (Array.isArray(res.places)) { try { localStorage.setItem(window.PLACES_KEY || "vigial_saved_places_v1", JSON.stringify(res.places)); } catch (e) {} }
    if (Array.isArray(res.myBairros)) { try { localStorage.setItem("vigial_my_bairros_v1", JSON.stringify(res.myBairros)); } catch (e) {} }
    if (res.profile) { saveProfileToStorage(res.profile); setProfile(res.profile); setEditing(false); }
  }

  function confirmVerificationCode() {
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    setVerifyLoading(true); setVerifyError("");
    let places = [];
    try { places = JSON.parse(localStorage.getItem(window.PLACES_KEY || "vigial_saved_places_v1") || "[]"); } catch (e) {}
    let myBairros = [];
    try { myBairros = JSON.parse(localStorage.getItem("vigial_my_bairros_v1") || "[]"); } catch (e) {}
    const myPremium = window.isPremium ? window.isPremium() : false;
    const myProfile = loadProfile();
    fetch(`${PROFILE_API_BASE}/verify-email/confirm`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ deviceId, code: verifyCode.trim(), premium: myPremium, places, myBairros, profile: myProfile }),
    })
      .then((r) => r.json())
      .then((res) => {
        setVerifyLoading(false);
        if (res.error) { setVerifyError(res.error); return; }
        applyLinkedAccountResult(res, verifyEmail.trim());
        if (!res.isReturningAccount && window.trackEvent) window.trackEvent("signup_complete");
        setVerifyStep("done");
      })
      .catch(() => { setVerifyLoading(false); setVerifyError(t(lang, "couldNotRegister")); });
  }

  function submitLogin() {
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    const cleanEmail = loginEmail.trim();
    if (!isValidEmail(cleanEmail)) { setLoginError(t(lang, "invalidEmailErr")); return; }
    if (!loginPassword) { setLoginError(t(lang, "loginPasswordRequiredErr")); return; }
    setLoginLoading(true); setLoginError("");
    let places = [];
    try { places = JSON.parse(localStorage.getItem(window.PLACES_KEY || "vigial_saved_places_v1") || "[]"); } catch (e) {}
    let myBairros = [];
    try { myBairros = JSON.parse(localStorage.getItem("vigial_my_bairros_v1") || "[]"); } catch (e) {}
    const myPremium = window.isPremium ? window.isPremium() : false;
    const myProfile = loadProfile();
    fetch(`${PROFILE_API_BASE}/auth/login`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ deviceId, email: cleanEmail, password: loginPassword, premium: myPremium, places, myBairros, profile: myProfile }),
    })
      .then((r) => r.json())
      .then((res) => {
        setLoginLoading(false);
        if (res.error) { setLoginError(res.error); return; }
        applyLinkedAccountResult(res, cleanEmail);
        setShowLoginForm(false);
        setLoginPassword("");
        setVerifyStep("done");
      })
      .catch(() => { setLoginLoading(false); setLoginError(t(lang, "couldNotRegister")); });
  }

  function resetForgotPasswordFlow() {
    setShowForgotPassword(false);
    setForgotStep("email");
    setForgotEmail(""); setForgotCode(""); setForgotNewPassword(""); setForgotConfirmPassword("");
    setForgotError("");
  }

  function sendForgotPasswordCode(emailOverride) {
    const cleanEmail = (emailOverride || forgotEmail).trim();
    if (!isValidEmail(cleanEmail)) { setForgotError(t(lang, "invalidEmailErr")); return; }
    setForgotLoading(true); setForgotError("");
    fetch(`${PROFILE_API_BASE}/auth/forgot-password`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: cleanEmail }),
    })
      .then((r) => r.json())
      .then((res) => {
        setForgotLoading(false);
        if (res.error) { setForgotError(res.error); return; }
        setForgotStep("code");
      })
      .catch(() => { setForgotLoading(false); setForgotError(t(lang, "couldNotSend")); });
  }

  function confirmForgotPasswordReset() {
    if (forgotNewPassword !== forgotConfirmPassword) { setForgotError(t(lang, "passwordMismatchErr")); return; }
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    setForgotLoading(true); setForgotError("");
    fetch(`${PROFILE_API_BASE}/auth/reset-password/confirm`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ deviceId, email: forgotEmail.trim(), code: forgotCode.trim(), password: forgotNewPassword }),
    })
      .then((r) => r.json())
      .then((res) => {
        setForgotLoading(false);
        if (res.error) { setForgotError(res.error); return; }
        applyLinkedAccountResult(res, forgotEmail.trim());
        resetForgotPasswordFlow();
        setShowLoginForm(false);
        setVerifyStep("done");
      })
      .catch(() => { setForgotLoading(false); setForgotError(t(lang, "passwordGenericErr")); });
  }

  function submitPassword() {
    setPasswordError("");
    if (newPasswordInput !== confirmPasswordInput) { setPasswordError(t(lang, "passwordMismatchErr")); return; }
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    setPasswordSaving(true);
    fetch(`${PROFILE_API_BASE}/auth/set-password`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ deviceId, currentPassword: currentPasswordInput, password: newPasswordInput }),
    })
      .then((r) => r.json())
      .then((res) => {
        setPasswordSaving(false);
        if (res.error) { setPasswordError(res.error); return; }
        setDeviceTrust((prev) => (prev ? { ...prev, hasPassword: true } : prev));
        setShowPasswordForm(false);
        setCurrentPasswordInput(""); setNewPasswordInput(""); setConfirmPasswordInput("");
        setPasswordSavedMsg(true);
        setTimeout(() => setPasswordSavedMsg(false), 2600);
      })
      .catch(() => { setPasswordSaving(false); setPasswordError(t(lang, "passwordGenericErr")); });
  }

  const passwordChecks = {
    length: newPasswordInput.length >= 8,
    lower: /[a-z]/.test(newPasswordInput),
    upper: /[A-Z]/.test(newPasswordInput),
    digit: /[0-9]/.test(newPasswordInput),
    special: /[!@#$%^&*()_+\-=[\]{}|;:'",.<>/?`~\\]/.test(newPasswordInput),
  };
  const passwordMeetsAllReqs = Object.values(passwordChecks).every(Boolean);

  function loadTrends() {
    setTrendsLoading(true);
    fetch(`${PROFILE_API_BASE}/reports?window=90d`)
      .then((r) => r.json())
      .then((reports) => {
        setTrends(computeTrends(reports));
        setTrendsLoading(false);
      })
      .catch(() => setTrendsLoading(false));
  }

  function toggleDigest() {
    const next = !digestEnabled;
    setDigestEnabled(next);
    saveDigestEnabled(next);
    if (window.pushAccountSync) window.pushAccountSync({ digestEnabled: next });
  }

  function loadDigestPreview() {
    setDigestLoading(true);
    const places = loadSavedPlacesForDigest();
    fetch(`${PROFILE_API_BASE}/reports?window=7d`)
      .then((r) => r.json())
      .then((reports) => {
        const items = places.map((p) => ({
          name: p.name,
          count: reports.filter((r) => window.haversineKm(p.lat, p.lng, r.lat, r.lng) * 1000 <= p.radius).length,
        }));
        setDigestPreview(items);
        setDigestLoading(false);
      })
      .catch(() => setDigestLoading(false));
  }

  async function handleUpgrade() {
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    if (!deviceId) return;
    setPlanMsg(t(lang, "premiumRedirecting"));
    try {
      const res = await fetch(`${PROFILE_API_BASE}/premium/checkout`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ deviceId, plan: selectedPlan }),
      }).then((r) => r.json());
      if (res.checkoutUrl) {
        if (window.trackEvent) window.trackEvent("premium_checkout_start");
        window.location.href = res.checkoutUrl;
        return;
      }
      setPlanMsg(res.error || t(lang, "premiumCheckoutError"));
    } catch (e) {
      setPlanMsg(t(lang, "premiumCheckoutError"));
    }
    setTimeout(() => setPlanMsg(null), 3200);
  }

  function pollForPixConfirmation(deviceId, attemptsLeft) {
    // Switching tabs unmounts this screen (App.jsx only renders it while
    // "perfil" is active) — without this guard the queued setTimeout chain
    // kept calling setState after unmount, and a payment confirmed while
    // the user was elsewhere never updated the UI until a manual reload.
    if (!mountedRef.current) return;
    if (attemptsLeft <= 0) { setPixPolling(false); return; }
    // Actively re-checks the pending payment with Mercado Pago instead of
    // just trusting our stored state — a real approved Pix payment once
    // went unreported because the MP webhook wasn't subscribed to
    // "payment" events, so this doesn't rely on the webhook alone.
    fetch(`${PROFILE_API_BASE}/premium/check-pix`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ deviceId }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (!mountedRef.current) return;
        if (data && data.premium) {
          fetch(`${PROFILE_API_BASE}/account-sync/mine`, {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ deviceId }),
          }).then((r) => r.json()).then((d) => { if (mountedRef.current) setAccountSync(d); }).catch(() => {});
          if (window.setPremium) window.setPremium(true);
          setPremiumState(true);
          setPixCharge(null);
          setPixPolling(false);
          return;
        }
        setTimeout(() => pollForPixConfirmation(deviceId, attemptsLeft - 1), 3000);
      })
      .catch(() => { if (mountedRef.current) setTimeout(() => pollForPixConfirmation(deviceId, attemptsLeft - 1), 3000); });
  }

  async function handlePixCheckout() {
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    if (!deviceId) return;
    setPlanMsg(null);
    setPixCharge(null);
    try {
      const res = await fetch(`${PROFILE_API_BASE}/premium/checkout-pix`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ deviceId, plan: selectedPlan }),
      }).then((r) => r.json());
      if (res.qrCodeBase64) {
        setPixCharge(res);
        setPixPolling(true);
        pollForPixConfirmation(deviceId, 40); // ~2 minutes at 3s intervals
        return;
      }
      setPlanMsg(res.error || t(lang, "premiumCheckoutError"));
      setTimeout(() => setPlanMsg(null), 3200);
    } catch (e) {
      setPlanMsg(t(lang, "premiumCheckoutError"));
      setTimeout(() => setPlanMsg(null), 3200);
    }
  }

  function copyPixCode() {
    if (!pixCharge) return;
    const done = () => { setPixCopied(true); setTimeout(() => setPixCopied(false), 2000); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(pixCharge.qrCodeCopyPaste).then(done).catch(() => {});
    }
  }

  async function handleCancelPremium() {
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    if (!deviceId) return;
    setPlanMsg(t(lang, "premiumCancelling"));
    try {
      const res = await fetch(`${PROFILE_API_BASE}/premium/cancel`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ deviceId }),
      }).then((r) => r.json());
      if (res.ok) {
        setPremium(false);
        setPremiumState(false);
        setPlanMsg(t(lang, "premiumCancelled"));
      } else {
        setPlanMsg(res.error || t(lang, "premiumCancelError"));
      }
    } catch (e) {
      setPlanMsg(t(lang, "premiumCancelError"));
    }
    setTimeout(() => setPlanMsg(null), 3200);
  }

  function handleSave() {
    const cleanName = name.trim();
    const cleanEmail = email.trim();
    const cleanUsername = username.trim();
    let hasErr = false;
    if (!cleanName) { setNameErr(true); hasErr = true; } else { setNameErr(false); }
    if (!isValidEmail(cleanEmail)) { setEmailErr(true); hasErr = true; } else { setEmailErr(false); }
    setUsernameErr(false);
    if (hasErr) return;

    setStatus("saving");
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    const newId = () => "u" + Date.now() + Math.random().toString(36).slice(2);

    function attemptSave(id, isRetry) {
      fetch(`${PROFILE_API_BASE}/users`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, deviceId, name: cleanName, email: cleanEmail, username: cleanUsername }),
      })
        .then((r) => r.json())
        .then((data) => {
          if (data.error) {
            if (data.error === "nome de usuario ja esta em uso") { setStatus("idle"); setUsernameErr(true); return; }
            if (data.error === "perfil pertence a outro dispositivo" && !isRetry) {
              // The stored profile id was created by a different deviceId
              // (cleared storage, different browser, etc.) — there's no
              // account system behind this lightweight profile, so the
              // best move is to start a fresh id on this device rather
              // than block the save entirely.
              attemptSave(newId(), true);
              return;
            }
            setStatus("error");
            return;
          }
          const saved = { id, name: data.name, email: data.email, username: cleanUsername, avatar: avatarDraft };
          setProfile(saved);
          saveProfileToStorage(saved);
          if (window.pushAccountSync) window.pushAccountSync({ profile: saved });
          setEditing(false);
          setStatus("saved");
          setTimeout(() => setStatus("idle"), 2200);
        })
        .catch(() => setStatus("error"));
    }

    attemptSave((profile && profile.id) || newId(), false);
  }

  function handleRemove() {
    setProfile(null);
    saveProfileToStorage(null);
    try { localStorage.removeItem(PROFILE_KEY); } catch (e) {}
    setName(""); setEmail(""); setUsername(""); setAvatarDraft(null); setCustomFace(window.DEFAULT_AVATAR_FACE); setEditing(true);
  }

  async function handleLogout() {
    const deviceId = window.getDeviceId ? window.getDeviceId() : null;
    // "Lembrar de mim" only controls whether the device stays linked
    // server-side for next time (so reopening the app auto-recognizes you
    // without re-entering a password) — it must NOT gate whether "Sair"
    // visibly logs you out right now. It used to: the local view state
    // (deviceTrust.verifiedEmail) only got cleared in the unchecked branch,
    // so with the box checked the "logged in" section never disappeared
    // and Sair looked like it did nothing.
    if (!rememberOnLogout && deviceId) {
      try {
        await fetch(`${PROFILE_API_BASE}/auth/logout`, {
          method: "POST", headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ deviceId }),
        });
      } catch (e) {}
    }
    setDeviceTrust({ trustScore: 0, trustLevel: 0, verifiedEmail: null, hasPassword: false });
    setIsReturningAccount(false);
    setVerifyStep("idle"); setVerifyEmail(""); setVerifyCode(""); setVerifyError(""); setShowLoginForm(false);
    if (window.setPremium) window.setPremium(false);
    setPremiumState(false);
    handleRemove();
  }

  function handleEdit() {
    setName(profile.name); setEmail(profile.email);
    setUsername(profile.username || ""); setAvatarDraft(profile.avatar || null);
    setCustomFace((profile.avatar && profile.avatar.type === "custom") ? migrateOldCustomFace(profile.avatar.value) : window.DEFAULT_AVATAR_FACE);
    setNameErr(false); setEmailErr(false); setAvatarError(null);
    setEditing(true);
  }

  function handlePhotoChange(e) {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) { setAvatarError(t(lang, "avatarInvalidType")); return; }
    setAvatarError(null);
    readAndResizeImage(file, 128)
      .then((dataUrl) => setAvatarDraft({ type: "photo", value: dataUrl }))
      .catch(() => setAvatarError(t(lang, "avatarUploadErr")));
  }

  function updateCustomFace(patch) {
    setCustomFace((prev) => {
      const next = { ...prev, ...patch };
      setAvatarDraft({ type: "custom", value: next });
      return next;
    });
  }

  function findOpt(list, id) {
    return (list || []).find((o) => o.id === id);
  }

  function colorSwatchRow(label, colors, field) {
    return (
      <React.Fragment>
        <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 5 }}>{label}</div>
        <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
          {colors.map((c) => {
            const active = customFace[field] === c;
            return (
              <button key={c} onClick={() => updateCustomFace({ [field]: c })} style={{
                width: 24, height: 24, borderRadius: "50%", background: c,
                border: active ? "2px solid var(--color-brand-primary)" : "2px solid transparent", cursor: "pointer", padding: 0,
              }} />
            );
          })}
        </div>
      </React.Fragment>
    );
  }

  function pillRow(label, options, field, clearField) {
    function pick(id) {
      const patch = { [field]: id };
      // Beard and mustache both draw into Avataaars' single facial-hair
      // slot — picking a real value for one clears the other so the UI
      // doesn't imply both can show at once.
      if (clearField && id !== window.DEFAULT_AVATAR_FACE[field]) patch[clearField] = window.DEFAULT_AVATAR_FACE[clearField];
      updateCustomFace(patch);
    }
    return (
      <React.Fragment>
        <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 5 }}>{label}</div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
          {options.map((o) => {
            const myTrustLevel = (deviceTrust && deviceTrust.trustLevel) || 0;
            const locked = (o.premium && !premium) || (o.minTrustLevel > 0 && myTrustLevel < o.minTrustLevel);
            const active = customFace[field] === o.id;
            if (o.swatch) {
              return (
                <button key={o.id} onClick={() => { if (!locked) pick(o.id); }} style={{
                  position: "relative", width: 24, height: 24, borderRadius: "50%", background: o.swatch,
                  border: active ? "2px solid var(--color-brand-primary)" : "2px solid transparent",
                  cursor: locked ? "not-allowed" : "pointer", padding: 0, opacity: locked ? 0.5 : 1,
                }}>
                  {locked && <Icon name="lock" size={9} color="#fff" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)" }} />}
                </button>
              );
            }
            return (
              <button key={o.id} onClick={() => { if (!locked) pick(o.id); }} style={{
                display: "flex", alignItems: "center", gap: 4, padding: "5px 9px", borderRadius: "var(--radius-pill)",
                border: `1px solid ${active ? "var(--color-brand-primary)" : "var(--color-border)"}`,
                background: active ? "var(--color-brand-tint)" : "transparent",
                cursor: locked ? "not-allowed" : "pointer", opacity: locked ? 0.5 : 1, fontFamily: "var(--font-body)",
                fontSize: "var(--text-xs)", color: active ? "var(--color-brand-deep)" : "var(--color-text-secondary)",
              }}>
                {t(lang, o.key)}
                {locked && <Icon name="lock" size={9} color="var(--color-text-muted)" />}
              </button>
            );
          })}
        </div>
      </React.Fragment>
    );
  }

  return (
    <div style={{ padding: 14, flex: 1, overflowY: "auto" }}>
      <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 12 }}>{t(lang, "profileIntro")}</div>

      {deviceTrust && (
        <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12, marginBottom: 12 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
            <span style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>{t(lang, "trustLevelTitle")}</span>
            <span style={{
              fontSize: "var(--text-xs)", fontWeight: "var(--weight-semibold)", padding: "2px 9px 2px 7px", borderRadius: "var(--radius-pill)",
              background: "var(--color-brand-tint)", color: "var(--color-brand-deep)", display: "inline-flex", alignItems: "center", gap: 4,
            }}>
              <Icon name={TRUST_LEVEL_STYLE[Math.min(deviceTrust.trustLevel, 3)].icon} size={12} color={TRUST_LEVEL_STYLE[Math.min(deviceTrust.trustLevel, 3)].color} />
              {t(lang, deviceTrust.trustLevel >= 3 ? "trustLevel3" : deviceTrust.trustLevel >= 2 ? "trustLevel2" : deviceTrust.trustLevel >= 1 ? "trustLevel1" : "trustLevel0")}
            </span>
          </div>

          {deviceTrust.verifiedEmail ? (
            <React.Fragment>
              <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: "var(--text-xs)", color: "var(--color-brand-primary)", marginBottom: 10 }}>
                <Icon name="badge-check" size={14} color="var(--color-brand-primary)" />
                {t(lang, "verifyEmailVerifiedBadge")} · {deviceTrust.verifiedEmail}
              </div>
              <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8, cursor: "pointer" }}>
                <input type="checkbox" checked={rememberOnLogout} onChange={(e) => setRememberOnLogout(e.target.checked)} />
                {t(lang, "logoutRememberLabel")}
              </label>
              <button
                onClick={handleLogout}
                style={{ width: "100%", background: "transparent", border: "1px solid var(--color-border)", borderRadius: 8, padding: "7px 0", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-secondary)", fontFamily: "var(--font-body)" }}
              >
                {t(lang, "logoutBtn")}
              </button>
            </React.Fragment>
          ) : verifyStep === "idle" ? (
            showForgotPassword ? (
              <React.Fragment>
                {forgotStep === "email" ? (
                  <React.Fragment>
                    <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8 }}>{t(lang, "forgotPasswordIntro")}</div>
                    <input
                      value={forgotEmail}
                      onChange={(e) => { setForgotEmail(e.target.value); setForgotError(""); }}
                      placeholder={t(lang, "verifyEmailPlaceholder")}
                      style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 9, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", marginBottom: 8 }}
                    />
                    {forgotError && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 8 }}>{forgotError}</div>}
                    <Button variant="primary" onClick={sendForgotPasswordCode} disabled={forgotLoading} style={{ width: "100%", marginBottom: 6 }}>{t(lang, "forgotPasswordSendBtn")}</Button>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 4 }}>{t(lang, "verifyEmailSentHint")}</div>
                    <div style={{ fontSize: "var(--text-sm)", fontFamily: "var(--font-mono)", marginBottom: 8 }}>{forgotEmail.trim()}</div>
                    <input
                      value={forgotCode}
                      onChange={(e) => { setForgotCode(e.target.value); setForgotError(""); }}
                      placeholder={t(lang, "verifyEmailCodePlaceholder")}
                      maxLength={6}
                      style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 9, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-mono)", marginBottom: 8, letterSpacing: 2 }}
                    />
                    <PasswordField
                      value={forgotNewPassword}
                      onChange={(e) => { setForgotNewPassword(e.target.value); setForgotError(""); }}
                      placeholder={t(lang, "forgotPasswordNewPlaceholder")}
                    />
                    <PasswordField
                      value={forgotConfirmPassword}
                      onChange={(e) => { setForgotConfirmPassword(e.target.value); setForgotError(""); }}
                      placeholder={t(lang, "forgotPasswordConfirmPlaceholder")}
                    />
                    {forgotError && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 8 }}>{forgotError}</div>}
                    <Button variant="primary" onClick={confirmForgotPasswordReset} disabled={forgotLoading || forgotCode.trim().length !== 6} style={{ width: "100%", marginBottom: 6 }}>{t(lang, "forgotPasswordResetBtn")}</Button>
                    <button onClick={() => { setForgotStep("email"); setForgotCode(""); setForgotError(""); }} style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)", marginBottom: 4 }}>
                      {t(lang, "verifyEmailResendBtn")}
                    </button>
                  </React.Fragment>
                )}
                <button onClick={resetForgotPasswordFlow} style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)" }}>
                  {t(lang, "loginBackBtn")}
                </button>
              </React.Fragment>
            ) : showLoginForm ? (
              <React.Fragment>
                <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8 }}>{t(lang, "loginIntro")}</div>
                <input
                  value={loginEmail}
                  onChange={(e) => { setLoginEmail(e.target.value); setLoginError(""); }}
                  placeholder={t(lang, "verifyEmailPlaceholder")}
                  style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 9, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", marginBottom: 8 }}
                />
                <PasswordField
                  value={loginPassword}
                  onChange={(e) => { setLoginPassword(e.target.value); setLoginError(""); }}
                  placeholder={t(lang, "loginPasswordPlaceholder")}
                />
                {loginError && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 8 }}>{loginError}</div>}
                <Button variant="primary" onClick={submitLogin} disabled={loginLoading} style={{ width: "100%", marginBottom: 6 }}>{t(lang, "loginBtn")}</Button>
                <button onClick={() => { setShowForgotPassword(true); setForgotEmail(loginEmail); }} style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-brand-primary)", fontFamily: "var(--font-body)", marginBottom: 6 }}>
                  {t(lang, "forgotPasswordLink")}
                </button>
                <button onClick={() => { setShowLoginForm(false); setLoginError(""); }} style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)" }}>
                  {t(lang, "loginBackBtn")}
                </button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8 }}>{t(lang, "verifyEmailIntro")}</div>
                <input
                  value={verifyEmail}
                  onChange={(e) => { setVerifyEmail(e.target.value); setVerifyError(""); }}
                  placeholder={t(lang, "verifyEmailPlaceholder")}
                  style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 9, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", marginBottom: 8 }}
                />
                <label style={{ display: "flex", alignItems: "flex-start", gap: 6, fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8, cursor: "pointer" }}>
                  <input type="checkbox" checked={acceptedTerms} onChange={(e) => { setAcceptedTerms(e.target.checked); setVerifyError(""); }} style={{ marginTop: 2 }} />
                  <span>
                    {t(lang, "signupAcceptTermsPrefix")}{" "}
                    <a href="termos.html" target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} style={{ color: "var(--color-brand-primary)" }}>{t(lang, "ajudaTermsLink")}</a>
                    {" "}{t(lang, "signupAcceptTermsAnd")}{" "}
                    <a href="privacidade.html" target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} style={{ color: "var(--color-brand-primary)" }}>{t(lang, "ajudaPrivacyLink")}</a>
                  </span>
                </label>
                {verifyError && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 8 }}>{verifyError}</div>}
                <Button variant="secondary" onClick={sendVerificationCode} disabled={verifyLoading || !acceptedTerms} style={{ width: "100%", marginBottom: 6 }}>{t(lang, "verifyEmailSendBtn")}</Button>
                <button onClick={() => setShowLoginForm(true)} style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)" }}>
                  {t(lang, "loginSectionToggle")}
                </button>
              </React.Fragment>
            )
          ) : verifyStep === "sent" ? (
            <React.Fragment>
              <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 4 }}>{t(lang, "verifyEmailSentHint")}</div>
              <div style={{ fontSize: "var(--text-sm)", fontFamily: "var(--font-mono)", marginBottom: 8 }}>{verifyEmail.trim()}</div>
              <input
                value={verifyCode}
                onChange={(e) => { setVerifyCode(e.target.value); setVerifyError(""); }}
                placeholder={t(lang, "verifyEmailCodePlaceholder")}
                maxLength={6}
                style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 9, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-mono)", marginBottom: 8, letterSpacing: 2 }}
              />
              {verifyError && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 8 }}>{verifyError}</div>}
              <Button variant="primary" onClick={confirmVerificationCode} disabled={verifyLoading || verifyCode.trim().length !== 6} style={{ width: "100%", marginBottom: 6 }}>{t(lang, "verifyEmailConfirmBtn")}</Button>
              <button onClick={() => { setVerifyStep("idle"); setVerifyCode(""); setVerifyError(""); }} style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)" }}>
                {t(lang, "verifyEmailResendBtn")}
              </button>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: "var(--text-xs)", color: "var(--color-brand-primary)" }}>
                <Icon name="badge-check" size={14} color="var(--color-brand-primary)" />
                {t(lang, isReturningAccount ? "verifyEmailWelcomeBack" : "verifyEmailDone")}
              </div>
              {!isReturningAccount && premiumTrialExpiresAt && (
                <div style={{ marginTop: 10, border: "1px solid var(--color-brand-primary)", borderRadius: "var(--radius-md)", padding: "9px 11px", background: "var(--color-brand-tint)" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: "var(--text-xs)", fontWeight: 700, color: "var(--color-brand-deep)", marginBottom: 3 }}>
                    <Icon name="sparkles" size={13} color="var(--color-brand-deep)" /> {t(lang, "betaPremiumTrialTitle")}
                  </div>
                  <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-secondary)" }}>
                    {t(lang, "betaPremiumTrialBody")} {new Date(premiumTrialExpiresAt).toLocaleDateString(lang === "en" ? "en-US" : lang === "es" ? "es-ES" : "pt-BR")}.
                  </div>
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      )}

      {deviceTrust && deviceTrust.verifiedEmail && (
        <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12, marginBottom: 12 }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
            <span style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>{t(lang, "passwordSectionTitle")}</span>
            {deviceTrust.hasPassword && (
              <span style={{
                fontSize: "var(--text-xs)", fontWeight: "var(--weight-semibold)", padding: "2px 9px 2px 7px", borderRadius: "var(--radius-pill)",
                background: "var(--color-brand-tint)", color: "var(--color-brand-deep)", display: "inline-flex", alignItems: "center", gap: 4,
              }}>
                <Icon name="lock" size={11} color="var(--color-brand-deep)" />
                {t(lang, "passwordProtectedBadge")}
              </span>
            )}
          </div>

          {!showPasswordForm ? (
            <React.Fragment>
              <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8 }}>
                {t(lang, deviceTrust.hasPassword ? "passwordProtectedNote" : "passwordCreateIntro")}
              </div>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowPasswordForm(true);
                  if (!deviceTrust.hasPassword) { setForgotEmail(deviceTrust.verifiedEmail); sendForgotPasswordCode(deviceTrust.verifiedEmail); }
                }}
                style={{ width: "100%" }}
              >
                {t(lang, deviceTrust.hasPassword ? "passwordChangeBtn" : "passwordCreateBtn")}
              </Button>
            </React.Fragment>
          ) : !deviceTrust.hasPassword ? (
            <React.Fragment>
              {/* First password ever on this account — proven via a one-time
                  email code (the same flow as "esqueci minha senha") instead
                  of trusting deviceId alone, which is guessable/leakable and
                  would otherwise let anyone who learned it take the account
                  over permanently. See set_password() in app.py. */}
              {forgotStep === "email" ? (
                <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8 }}>
                  {forgotLoading ? t(lang, "passwordCodeSendingMsg") : forgotError}
                  {!forgotLoading && forgotError && (
                    <Button variant="secondary" onClick={() => sendForgotPasswordCode(deviceTrust.verifiedEmail)} style={{ width: "100%", marginTop: 8 }}>
                      {t(lang, "verifyEmailResendBtn")}
                    </Button>
                  )}
                </div>
              ) : (
                <React.Fragment>
                  <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 4 }}>{t(lang, "verifyEmailSentHint")}</div>
                  <div style={{ fontSize: "var(--text-sm)", fontFamily: "var(--font-mono)", marginBottom: 8 }}>{deviceTrust.verifiedEmail}</div>
                  <input
                    value={forgotCode}
                    onChange={(e) => { setForgotCode(e.target.value); setForgotError(""); }}
                    placeholder={t(lang, "verifyEmailCodePlaceholder")}
                    maxLength={6}
                    style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 9, borderRadius: 8, border: "1px solid var(--color-border)", background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-mono)", marginBottom: 8, letterSpacing: 2 }}
                  />
                  <PasswordField
                    value={forgotNewPassword}
                    onChange={(e) => { setForgotNewPassword(e.target.value); setForgotError(""); }}
                    placeholder={t(lang, "passwordNewPlaceholder")}
                  />
                  <PasswordField
                    value={forgotConfirmPassword}
                    onChange={(e) => { setForgotConfirmPassword(e.target.value); setForgotError(""); }}
                    placeholder={t(lang, "passwordConfirmPlaceholder")}
                  />
                  {forgotError && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 8 }}>{forgotError}</div>}
                  <Button
                    variant="primary"
                    onClick={confirmForgotPasswordReset}
                    disabled={forgotLoading || forgotCode.trim().length !== 6 || !forgotNewPassword || forgotNewPassword !== forgotConfirmPassword}
                    style={{ width: "100%", marginBottom: 6 }}
                  >
                    {t(lang, "passwordCreateBtn")}
                  </Button>
                  <button onClick={() => { setForgotStep("email"); setForgotCode(""); setForgotError(""); sendForgotPasswordCode(deviceTrust.verifiedEmail); }} style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)", marginBottom: 4 }}>
                    {t(lang, "verifyEmailResendBtn")}
                  </button>
                </React.Fragment>
              )}
              <button
                onClick={() => { setShowPasswordForm(false); resetForgotPasswordFlow(); }}
                style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)" }}
              >
                {t(lang, "passwordCancelBtn")}
              </button>
            </React.Fragment>
          ) : (
            // Only reachable with deviceTrust.hasPassword true — creating
            // the first password is handled by the branch above instead.
            <React.Fragment>
              <PasswordField
                value={currentPasswordInput}
                onChange={(e) => { setCurrentPasswordInput(e.target.value); setPasswordError(""); }}
                placeholder={t(lang, "passwordCurrentPlaceholder")}
              />
              <PasswordField
                value={newPasswordInput}
                onChange={(e) => { setNewPasswordInput(e.target.value); setPasswordError(""); }}
                placeholder={t(lang, "passwordNewPlaceholder")}
              />
              <PasswordField
                value={confirmPasswordInput}
                onChange={(e) => { setConfirmPasswordInput(e.target.value); setPasswordError(""); }}
                placeholder={t(lang, "passwordConfirmPlaceholder")}
              />
              <div style={{ display: "flex", flexDirection: "column", gap: 3, marginBottom: 10 }}>
                {[
                  [passwordChecks.length, "passwordReqLength"],
                  [passwordChecks.lower, "passwordReqLower"],
                  [passwordChecks.upper, "passwordReqUpper"],
                  [passwordChecks.digit, "passwordReqDigit"],
                  [passwordChecks.special, "passwordReqSpecial"],
                ].map(([ok, key]) => (
                  <div key={key} style={{ fontSize: "var(--text-xs)", color: ok ? "var(--color-brand-primary)" : "var(--color-text-muted)" }}>
                    {ok ? "✓" : "○"} {t(lang, key)}
                  </div>
                ))}
              </div>
              {passwordError && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 8 }}>{passwordError}</div>}
              <Button
                variant="primary"
                onClick={submitPassword}
                disabled={passwordSaving || !passwordMeetsAllReqs || newPasswordInput !== confirmPasswordInput || !currentPasswordInput}
                style={{ width: "100%", marginBottom: 6 }}
              >
                {t(lang, "passwordChangeBtn")}
              </Button>
              <button
                onClick={() => { setShowPasswordForm(false); setPasswordError(""); setCurrentPasswordInput(""); setNewPasswordInput(""); setConfirmPasswordInput(""); }}
                style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)" }}
              >
                {t(lang, "passwordCancelBtn")}
              </button>
            </React.Fragment>
          )}
          {passwordSavedMsg && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-brand-primary)", marginTop: 8 }}>{t(lang, "passwordSavedMsg")}</div>}
        </div>
      )}

      <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12, marginBottom: 12 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
          <span style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>{t(lang, "planLabel")}</span>
          <span style={{
            fontSize: "var(--text-xs)", fontWeight: "var(--weight-semibold)", padding: "2px 9px", borderRadius: "var(--radius-pill)",
            background: premium ? "var(--color-brand-primary)" : "var(--color-brand-tint)",
            color: premium ? "#fff" : "var(--color-brand-deep)",
          }}>{premium ? t(lang, "planPremium") : t(lang, "planFree")}</span>
        </div>

        {!premium && (
          <React.Fragment>
            <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 10 }}>{t(lang, "planFreeDesc")}</div>
            <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-secondary)", fontWeight: "var(--weight-semibold)", marginBottom: 6 }}>{t(lang, "premiumBenefitsTitle")}</div>
            <ul style={{ margin: "0 0 12px", paddingLeft: 18, fontSize: "var(--text-xs)", color: "var(--color-text-secondary)" }}>
              <li>{t(lang, "premiumBenefit1")}</li>
              <li>{t(lang, "premiumBenefit2")}</li>
              <li>{t(lang, "premiumBenefit3")}</li>
            </ul>
            {(window.isTWA ? window.isTWA() : false) ? (
              <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "premiumWebOnlyNote")}</div>
            ) : (
              <React.Fragment>
            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
              <button
                onClick={() => setSelectedPlan("monthly")}
                style={{
                  flex: 1, textAlign: "left", padding: "10px 12px", borderRadius: "var(--radius-lg)", cursor: "pointer",
                  border: selectedPlan === "monthly" ? "2px solid var(--color-brand-primary)" : "1px solid var(--color-border)",
                  background: selectedPlan === "monthly" ? "var(--color-brand-tint)" : "transparent",
                  fontFamily: "var(--font-body)",
                }}
              >
                <div style={{ fontSize: "var(--text-xs)", color: selectedPlan === "monthly" ? "var(--color-brand-deep)" : "var(--color-text-secondary)", marginBottom: 2 }}>{t(lang, "planMonthlyLabel")}</div>
                <div style={{ fontSize: "var(--text-base)", fontWeight: 700, color: selectedPlan === "monthly" ? "var(--color-brand-deep)" : "var(--color-text-primary)" }}>{t(lang, "premiumPricingNote")}</div>
              </button>
              <button
                onClick={() => setSelectedPlan("annual")}
                style={{
                  flex: 1, textAlign: "left", padding: "10px 12px", borderRadius: "var(--radius-lg)", cursor: "pointer",
                  border: selectedPlan === "annual" ? "2px solid var(--color-brand-primary)" : "1px solid var(--color-border)",
                  background: selectedPlan === "annual" ? "var(--color-brand-tint)" : "transparent",
                  fontFamily: "var(--font-body)",
                }}
              >
                <div style={{ fontSize: "var(--text-xs)", color: selectedPlan === "annual" ? "var(--color-brand-deep)" : "var(--color-text-secondary)", marginBottom: 2 }}>{t(lang, "planAnnualLabel")}</div>
                <div style={{ fontSize: "var(--text-base)", fontWeight: 700, color: selectedPlan === "annual" ? "var(--color-brand-deep)" : "var(--color-text-primary)" }}>{t(lang, "premiumPricingNoteAnnual")}</div>
                <div style={{ fontSize: "var(--text-xs)", color: selectedPlan === "annual" ? "var(--color-brand-deep)" : "var(--color-brand-primary)", fontWeight: 600, marginTop: 2 }}>{t(lang, "planAnnualSavings")}</div>
              </button>
            </div>
            <Button variant="primary" onClick={handleUpgrade} style={{ width: "100%", marginBottom: 8 }}>{t(lang, "upgradeButton")}</Button>
            <Button variant="secondary" onClick={handlePixCheckout} style={{ width: "100%" }}>{t(lang, "payWithPixBtn")}</Button>
              </React.Fragment>
            )}

            {pixCharge && (
              <div style={{ marginTop: 12, padding: 12, border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", textAlign: "center" }}>
                <img
                  src={`data:image/png;base64,${pixCharge.qrCodeBase64}`}
                  alt="QR Code Pix"
                  style={{ width: 160, height: 160, margin: "0 auto 10px", display: "block", borderRadius: 8 }}
                />
                <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8 }}>{t(lang, "pixInstructions")}</div>
                <div style={{
                  fontSize: 10, fontFamily: "var(--font-mono)", color: "var(--color-text-secondary)", background: "var(--color-bg)",
                  border: "1px solid var(--color-border)", borderRadius: 6, padding: 8, marginBottom: 8, wordBreak: "break-all", textAlign: "left",
                }}>
                  {pixCharge.qrCodeCopyPaste}
                </div>
                <Button variant="secondary" onClick={copyPixCode} style={{ width: "100%", marginBottom: 8 }}>
                  {pixCopied ? t(lang, "pixCopiedMsg") : t(lang, "pixCopyBtn")}
                </Button>
                {pixPolling && (
                  <div style={{ fontSize: "var(--text-xs)", color: "var(--color-brand-primary)", marginBottom: 4 }}>{t(lang, "pixWaitingMsg")}</div>
                )}
                <button
                  onClick={() => { setPixCharge(null); setPixPolling(false); }}
                  style={{ width: "100%", background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)" }}
                >
                  {t(lang, "pixCancelBtn")}
                </button>
              </div>
            )}
          </React.Fragment>
        )}

        {premium && (
          <React.Fragment>
            {accountSync && accountSync.hasActiveSubscription ? (
              <React.Fragment>
                <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 10 }}>{t(lang, "premiumActiveNote")}</div>
                <Button variant="ghost" onClick={handleCancelPremium} style={{ width: "100%" }}>{t(lang, "cancelPremiumButton")}</Button>
              </React.Fragment>
            ) : accountSync && accountSync.premiumExpiresAt ? (
              <React.Fragment>
                <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-secondary)", marginBottom: 4 }}>
                  {t(lang, "premiumExpiresPrefix")} {new Date(accountSync.premiumExpiresAt).toLocaleDateString(lang === "en" ? "en-US" : lang === "es" ? "es-ES" : "pt-BR")}
                </div>
                <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "premiumPixNoRenewNote")}</div>
              </React.Fragment>
            ) : (
              <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "premiumActiveNote")}</div>
            )}
          </React.Fragment>
        )}

        {planMsg && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-brand-primary)", marginTop: 8 }}>{planMsg}</div>}
      </div>

      {premium && (
        <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12, marginBottom: 12 }}>
          <button onClick={toggleDigest} style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", background: "transparent", border: "none", cursor: "pointer", fontFamily: "var(--font-body)" }}>
            <span style={{ fontSize: "var(--text-sm)", color: "var(--color-text-primary)" }}>{t(lang, "weeklyDigestTitle")}</span>
            <span style={{
              width: 36, height: 20, borderRadius: 999, background: digestEnabled ? "var(--color-brand-primary)" : "var(--color-border)",
              position: "relative", flexShrink: 0, transition: "background .15s",
            }}>
              <span style={{ position: "absolute", top: 2, left: digestEnabled ? 18 : 2, width: 16, height: 16, borderRadius: "50%", background: "#fff", transition: "left .15s" }} />
            </span>
          </button>
          <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", margin: "8px 0" }}>{t(lang, "weeklyDigestNote")}</div>
          <Button variant="secondary" onClick={loadDigestPreview} disabled={digestLoading} style={{ width: "100%" }}>{t(lang, "weeklyDigestPreviewBtn")}</Button>
          {digestPreview && (
            <div style={{ marginTop: 10, border: "1px solid var(--color-border)", borderRadius: 8, padding: 10, background: "var(--color-bg)" }}>
              <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-mono)", marginBottom: 6 }}>{t(lang, "weeklyDigestSubject")}</div>
              {digestPreview.length === 0 && <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>{t(lang, "weeklyDigestNoPlaces")}</div>}
              {digestPreview.length > 0 && digestPreview.every((p) => p.count === 0) && (
                <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>{t(lang, "weeklyDigestNoOccurrences")}</div>
              )}
              {digestPreview.filter((p) => p.count > 0).map((p, i) => (
                <div key={i} style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", padding: "3px 0" }}>
                  <b style={{ color: "var(--color-text-primary)" }}>{p.name}</b>: {p.count} {t(lang, "weeklyDigestCountSuffix")}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {premium && (
        <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12, marginBottom: 12 }}>
          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-primary)", marginBottom: 4 }}>{t(lang, "trendsTitle")}</div>
          <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 8 }}>{t(lang, "trendsNote")}</div>
          <Button variant="secondary" onClick={loadTrends} disabled={trendsLoading} style={{ width: "100%" }}>{t(lang, "trendsBtn")}</Button>
          {trends && (
            <div style={{ marginTop: 10 }}>
              {trends.totalPeriodA === 0 ? (
                <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)" }}>{t(lang, "trendsNoData")}</div>
              ) : (
                <React.Fragment>
                  <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 4 }}>{t(lang, "trendsTopCategory")}</div>
                  <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-primary)", marginBottom: 10 }}>
                    {trends.topCategory ? `${catLabelForTrends(lang, trends.topCategory)} (${trends.topCategoryCount})` : "-"}
                  </div>
                  <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)", marginBottom: 4 }}>{t(lang, "trendsTopBairros")}</div>
                  {trends.ranked.map((r, i) => {
                    const arrow = r.count > r.prevCount ? "▲" : r.count < r.prevCount ? "▼" : "–";
                    const arrowColor = r.count > r.prevCount ? "var(--color-alert)" : r.count < r.prevCount ? "var(--color-brand-primary)" : "var(--color-text-muted)";
                    return (
                      <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", padding: "4px 0", borderTop: i > 0 ? "1px solid var(--color-border)" : "none" }}>
                        <span>{i + 1}. {r.bairro}</span>
                        <span style={{ fontFamily: "var(--font-mono)", display: "flex", alignItems: "center", gap: 5 }}>
                          {r.count}
                          <span style={{ color: arrowColor }}>{arrow}</span>
                        </span>
                      </div>
                    );
                  })}
                </React.Fragment>
              )}
            </div>
          )}
        </div>
      )}

      {!editing && profile && (
        <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12, marginBottom: 12 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <AvatarBadge avatar={profile.avatar} size={40} />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-muted)" }}>{t(lang, "registeredAs")}</div>
              <div style={{ fontSize: "var(--text-base)", fontWeight: 600 }}>{profile.username ? profile.username : profile.name}</div>
              {profile.username && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-secondary)" }}>{profile.name}</div>}
              <div style={{ fontSize: "var(--text-xs)", color: "var(--color-text-secondary)", fontFamily: "var(--font-mono)" }}>{profile.email}</div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <Button variant="secondary" onClick={handleEdit} style={{ flex: 1 }}>{t(lang, "editProfile")}</Button>
          </div>
          <button onClick={handleRemove} style={{ width: "100%", marginTop: 8, background: "transparent", border: "none", cursor: "pointer", fontSize: "var(--text-xs)", color: "var(--color-text-muted)", fontFamily: "var(--font-body)" }}>
            {t(lang, "removeProfile")}
          </button>
        </div>
      )}

      {editing && (
        <div style={{ border: "1px solid var(--color-border)", borderRadius: "var(--radius-lg)", padding: 12 }}>
          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 4 }}>{t(lang, "nameLabel")}</div>
          <input
            value={name}
            onChange={(e) => { setName(e.target.value); setNameErr(false); }}
            placeholder={t(lang, "namePlaceholder")}
            style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 9, borderRadius: 8, border: `1px solid ${nameErr ? "var(--color-alert)" : "var(--color-border)"}`, background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", marginBottom: 4 }}
          />
          {nameErr && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 6 }}>{t(lang, "profileNameRequiredErr")}</div>}

          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", margin: "8px 0 4px" }}>{t(lang, "emailLabel")}</div>
          <input
            value={email}
            onChange={(e) => { setEmail(e.target.value); setEmailErr(false); }}
            placeholder={t(lang, "emailPlaceholder")}
            style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 9, borderRadius: 8, border: `1px solid ${emailErr ? "var(--color-alert)" : "var(--color-border)"}`, background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", marginBottom: 4 }}
          />
          {emailErr && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 6 }}>{t(lang, "invalidEmailErr")}</div>}

          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", margin: "8px 0 4px" }}>{t(lang, "usernameLabel")}</div>
          <input
            value={username}
            onChange={(e) => { setUsername(e.target.value); setUsernameErr(false); }}
            placeholder={t(lang, "usernamePlaceholder")}
            style={{ width: "100%", boxSizing: "border-box", fontSize: "var(--text-sm)", padding: 9, borderRadius: 8, border: `1px solid ${usernameErr ? "var(--color-alert)" : "var(--color-border)"}`, background: "var(--color-bg)", color: "var(--color-text-primary)", fontFamily: "var(--font-body)", marginBottom: usernameErr ? 4 : 10 }}
          />
          {usernameErr && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 6 }}>{t(lang, "usernameTakenErr")}</div>}

          <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 6 }}>{t(lang, "avatarLabel")}</div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
            <AvatarBadge avatar={avatarDraft} size={44} />
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <button onClick={() => fileInputRef.current && fileInputRef.current.click()} style={{ fontSize: "var(--text-xs)", padding: "5px 10px", borderRadius: "var(--radius-pill)", border: "1px solid var(--color-border)", background: "transparent", color: "var(--color-text-secondary)", cursor: "pointer", fontFamily: "var(--font-body)" }}>
                {t(lang, "uploadPhotoBtn")}
              </button>
              {avatarDraft && (
                <button onClick={() => setAvatarDraft(null)} style={{ fontSize: "var(--text-xs)", padding: "5px 10px", borderRadius: "var(--radius-pill)", border: "none", background: "transparent", color: "var(--color-text-muted)", cursor: "pointer", fontFamily: "var(--font-body)" }}>
                  {t(lang, "removePhotoBtn")}
                </button>
              )}
            </div>
            <input ref={fileInputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handlePhotoChange} />
          </div>
          {avatarError && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", marginBottom: 8 }}>{avatarError}</div>}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 8, marginBottom: 6 }}>
            {AVATAR_PRESETS.map((p) => {
              const active = avatarDraft && avatarDraft.type === "preset" && avatarDraft.value === p.id;
              const locked = p.premium && !premium;
              return (
                <button
                  key={p.id}
                  onClick={() => { if (!locked) setAvatarDraft({ type: "preset", value: p.id }); }}
                  style={{
                    background: "transparent", border: active ? "2px solid var(--color-brand-primary)" : "2px solid transparent", borderRadius: "50%", padding: 2,
                    cursor: locked ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                  }}
                >
                  <AvatarBadge avatar={{ type: "preset", value: p.id }} size={32} locked={locked} />
                </button>
              );
            })}
          </div>
          <div style={{ borderTop: "1px solid var(--color-border)", paddingTop: 10, marginTop: 4 }}>
            <div style={{ fontSize: "var(--text-sm)", color: "var(--color-text-secondary)", marginBottom: 10 }}>{t(lang, "customAvatarTitle")}</div>
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 14 }}>
              <window.AvatarSvg face={customFace} size={148} />
            </div>

            {pillRow(t(lang, "backgroundLabel"), window.AVATAR_BACKGROUNDS.map((o) => ({ ...o, swatch: o.color })), "background")}
            {pillRow(t(lang, "skinLabel"), window.AVATAR_SKIN_TONES.map((o) => ({ ...o, swatch: o.color })), "skin")}
            {pillRow(t(lang, "hairStyleLabel"), window.AVATAR_HAIR_STYLES, "hairStyle")}
            {(findOpt(window.AVATAR_HAIR_STYLES, customFace.hairStyle) || {}).isHat && colorSwatchRow(t(lang, "hatColorLabel"), window.AVATAR_ACCENT_COLORS, "hatColor")}
            {pillRow(t(lang, "hairColorLabel"), window.AVATAR_HAIR_COLORS.map((o) => ({ ...o, swatch: o.color })), "hairColor")}
            {pillRow(t(lang, "eyeColorLabel"), window.AVATAR_EYE_COLORS.map((o) => ({ ...o, swatch: o.color })), "eyeColor")}
            {pillRow(t(lang, "browLabel"), window.AVATAR_EYEBROWS, "eyebrows")}
            {pillRow(t(lang, "mouthLabel"), window.AVATAR_MOUTHS, "mouth")}
            {pillRow(t(lang, "beardLabel"), window.AVATAR_BEARDS, "beard", "mustache")}
            {pillRow(t(lang, "mustacheLabel"), window.AVATAR_MUSTACHES, "mustache", "beard")}
            {pillRow(t(lang, "glassesLabel"), window.AVATAR_GLASSES, "glasses")}
            {customFace.glasses !== "nenhum" && colorSwatchRow(t(lang, "glassesColorLabel"), window.AVATAR_ACCENT_COLORS, "glassesColor")}
            {pillRow(t(lang, "clothingLabel"), window.AVATAR_CLOTHING, "clothing")}
            {colorSwatchRow(t(lang, "clothingColorLabel"), window.AVATAR_CLOTHING_COLORS, "clothingColor")}
            {pillRow(t(lang, "specialUniformLabel"), window.AVATAR_SPECIAL_UNIFORMS, "specialUniform")}

            <Button
              variant={avatarDraft && avatarDraft.type === "custom" ? "primary" : "secondary"}
              onClick={() => setAvatarDraft({ type: "custom", value: customFace })}
              style={{ width: "100%" }}
            >
              {t(lang, "useCustomAvatarBtn")}
            </Button>
          </div>

          {status === "error" && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-alert)", margin: "6px 0" }}>{t(lang, "profileSaveErr")}</div>}
          {status === "saved" && <div style={{ fontSize: "var(--text-xs)", color: "var(--color-brand-primary)", margin: "6px 0" }}>{t(lang, "profileSaved")}</div>}

          <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
            {profile && (
              <Button variant="ghost" onClick={() => { setEditing(false); setNameErr(false); setEmailErr(false); }} style={{ flex: 1 }}>{t(lang, "cancel")}</Button>
            )}
            <Button variant="primary" onClick={handleSave} disabled={status === "saving"} style={{ flex: 1 }}>{t(lang, "saveProfile")}</Button>
          </div>
        </div>
      )}
    </div>
  );
}
window.ProfileScreen = ProfileScreen;
